import type { TemplateEntityV1beta3 } from '@backstage/plugin-scaffolder-common';
import type { TemplateGroupFilter } from '@backstage/plugin-scaffolder-react';

/**
 * Template groups for the scaffolder page, organized by owner.
 *
 * To add a new team's group, add an entry here with:
 * - title: The display name shown as the section header
 * - filter: A function that matches templates by spec.owner
 */
export const templateOwnerGroups: TemplateGroupFilter[] = [
  {
    title: 'Software Apps & Pipelines (SWAP)',
    filter: (entity: TemplateEntityV1beta3) => entity.spec.owner === 'dpe-development-systems-swap',
  },
  {
    title: 'Data Products Platform Infrastructure',
    filter: (entity: TemplateEntityV1beta3) => entity.spec.owner === 'data-products-platform',
  },
  {
    title: 'Work Item Tracking (WIT)',
    filter: (entity: TemplateEntityV1beta3) => entity.spec.owner === 'dpe-development-systems-wit',
  },
  {
    title: 'DPE Security',
    filter: (entity: TemplateEntityV1beta3) => entity.spec.owner === 'dpe-security',
  },
  {
    title: 'Site Reliability Engineering - SRE',
    filter: (entity: TemplateEntityV1beta3) => entity.spec.owner === 'dpe-operations-sre',
  },
];
